<template>
  <div class="person">
    <div class="treelist">
      <div class="tab" @click="changeTab(0)" :class="tabFlag == 0 ? 'active' : ''">栏目列表</div>
      <div class="tab" @click="changeTab(1)" :class="tabFlag == 1 ? 'active' : ''">专题列表</div>
      <a-input-search v-model="searchStr" placeholder="请输入关键字" style="width: 200px;opacity:0;" @search="onSearch" />
    </div>
    <!-- selectedKeys是选中项key的集合，expandedKeys是展开项key的集合 -->
    <a-tree v-if="treeData.length && tabFlag == 0" checkable v-model="cwCheckedKeys" :treeData="treeData"
      :selected-keys="selectedKeys" :expanded-keys="expandedKeys" @expand="onExpand"
      :auto-expand-parent="autoExpandParent" @check="onCheck" @select="onSelect" class="person-tree">
      <template slot="name" slot-scope="{ name }">
        <span style="color:#000000;" v-html="
            name.replace(
              new RegExp(searchValue, 'g'),
              '<span style=color:#f50>' + searchValue + '</span>'
            )
          "></span>
      </template>
    </a-tree>

    <a-tree v-if="treeDataC.length && tabFlag == 1" checkable v-model="cwCheckedKeysC" :treeData="treeDataC"
      :selected-keys="selectedKeysC" :expanded-keys="expandedKeysC" @expand="onExpandC"
      :auto-expand-parent="autoExpandParentC" @check="onCheckC" @select="onSelectC" class="person-tree">
      <template slot="name" slot-scope="{ name }">
        <span style="color:#000000;" v-html="
            name.replace(
              new RegExp(searchValue, 'g'),
              '<span style=color:#f50>' + searchValue + '</span>'
            )
          "></span>
      </template>
    </a-tree>
  </div>
</template>
<script>
  import {
    columnlist,
    treeList,
    listspecial,
    specialColumn
  } from "@/api/content";
  export default {
    name: "Person",
    props: ["selectid", "show", "checkedKeys", "checkedKeysC"],
    components: {},
    watch: {
      selectid(val) {
        if (val) {
          this.columnlistapi(val);
          this.listspecialapi(val)
        }
      },
      id(val) {
        if (val) {
          this.columnlistapi(val);
          this.listspecialapi(val)
        }
      },
      checkedKeys: {
        deep: true,
        handler(newValue) {
          this.cwCheckedKeys = Array.from(new Set(newValue));
          console.log("栏目更新", this.cwCheckedKeys);
        },
      },
      checkedKeysC: {
        deep: true,
        handler(newValue) {
          this.cwCheckedKeysC = Array.from(new Set(newValue));
          console.log("专题更新", this.cwCheckedKeysC);
        },
      },
    },
    data() {
      return {
        id: null,
        expandedKeys: [],
        expandedKeysC: [],
        backupsExpandedKeys: [],
        autoExpandParent: true,
        autoExpandParentC: true,
        // checkedKeys: [],
        cwCheckedKeys: [],
        cwCheckedKeysC: [],
        selectedKeys: [],
        selectedKeysC: [],
        searchValue: "",
        treeData: [],
        treeDataC: [],
        searchStr: "",

        tabFlag: 0
      };
    },
    methods: {
      changeTab(i) {
        this.tabFlag = i
        console.log(this.treeDataC);
      },
      columnlistapi(val) {
        let params = {
          channelId: val,
        };
        treeList(params).then((res) => {
          console.log(res);
          this.treeData = res;
        });
      },
      async listspecialapi(val) {
        let params = {
          channelId: val,
          pageSize: 100
        };
        let specialInfo = await listspecial(params)
        if (specialInfo.status) {
          let spData = specialInfo.data
          let allData = []
          for (let i = 0; i < spData.length; i++) {
            allData.push({
              key: spData[i].id,
              name: spData[i].title,
              scopedSlots: {
                title: "name"
              },
              disabled: true,
              children: []
            })
            let cparams = {
              specialId: spData[i].id,
              channelId: val,
              pageSize: 100,
              type: 'special'
            }
            let columnInfo = await specialColumn(cparams)
            if (columnInfo.data.length > 0) {
              for (let j = 0; j < columnInfo.data.length; j++) {
                allData[i].children.push({
                  key: columnInfo.data[j].id,
                  name: columnInfo.data[j].name,
                  scopedSlots: {
                    title: "name"
                  },
                  children: []
                })

              }
            }

          }
          this.treeDataC = allData
        }
      },

      onSearch() {
        this.searchValue = this.searchStr;
        if (this.searchValue === "") {
          this.expandedKeys = [];
        } else {
          this.expandedKeys = [];
          this.backupsExpandedKeys = [];
          const candidateKeysList = this.getkeyList(
            this.searchValue,
            this.treeData,
            []
          );
          candidateKeysList.forEach((item) => {
            const key = this.getParentKey(item, this.treeData);
            // eslint-disable-next-line no-shadow
            if (key && !this.backupsExpandedKeys.some((item) => item === key))
              this.backupsExpandedKeys.push(key);
          });
          const {
            length
          } = this.backupsExpandedKeys;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < length; i++) {
            this.getAllParentKey(this.backupsExpandedKeys[i], this.treeData);
          }
          this.expandedKeys = this.backupsExpandedKeys.slice();
        }
      },
      // 获取节点中含有value的所有key集合
      getkeyList(value, tree, keyList) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.name.indexOf(value) > -1) {
            keyList.push(node.key);
          }
          if (node.children) {
            this.getkeyList(value, node.children, keyList);
          }
        }
        return keyList;
      },
      // 该递归主要用于获取key的父亲节点的key值
      getParentKey(key, tree) {
        let parentKey;
        let temp;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.children) {
            if (node.children.some((item) => item.key === key)) {
              parentKey = node.key;
              // eslint-disable-next-line no-cond-assign
            } else if ((temp = this.getParentKey(key, node.children))) {
              parentKey = temp;
            }
          }
        }
        return parentKey;
      },
      // 获取该节点的所有祖先节点
      getAllParentKey(key, tree) {
        let parentKey;
        if (key) {
          parentKey = this.getParentKey(key, tree);
          if (parentKey) {
            if (!this.backupsExpandedKeys.some((item) => item === parentKey)) {
              this.backupsExpandedKeys.push(parentKey);
            }
            this.getAllParentKey(parentKey, tree);
          }
        }
      },
      onExpand(expandedKeys) {
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      onExpandC(expandedKeys) {
        this.expandedKeysC = expandedKeys;
        this.autoExpandParentC = false;
      },
      getChidlren(id) {
        var hasFound = false, // 表示是否有找到id值
          result = null;
        var fn = function (data) {
          if (Array.isArray(data) && !hasFound) {
            // 判断是否是数组并且没有的情况下，
            data.forEach((item) => {
              if (item.key === id) {
                // 数据循环每个子项，并且判断子项下边是否有id值
                result = item; // 返回的结果等于每一项
                hasFound = true; // 并且找到id值
              } else if (item.children) {
                fn(item.children); // 递归调用下边的子项
              }
            });
          }
        };
        fn(this.treeData); // 调用一下
        return result.name;
      },

      findPnodeId(data, nodeId) {
        //设置结果
        let result;
        if (!data) {
          return; //如果data传空，直接返回
        }
        for (let j = 0; j < data.length; j++) {
          for (var i = 0; i < data[j].children.length; i++) {
            let item = data[j].children[i];
            if (item.key == nodeId) {
              result = data[j]
              //找到id相等的则返回父id
              return result.key;
            } else if (item.children && item.children.length > 0) {
              //如果有子集，则把子集作为参数重新执行本方法
              result = findPnodeId(item, nodeId);
              //关键，千万不要直接return本方法，不然即使没有返回值也会将返回return，导致最外层循环中断，直接返回undefined,要有返回值才return才对
              if (result) {
                return result;
              }
            }
          }

        }

        //如果执行循环中都没有return，则在此return
        return result;
      },

      onCheckC(checkedKeys, {
        checked,
        checkedNodes,
        node,
        event
      }) {
        this.$emit("sitenamenumC", checkedKeys);
        this.cwCheckedKeysC = Array.from(new Set(this.checkedKeysC));
        if (checked) {
          let arr = [];
          let arrid = [];
          let cKeys = checkedKeys;
          cKeys = checkedKeys;
          cKeys.forEach((item) => {
            if (this.getName(this.treeDataC, item)) {
              arr.push(this.getName(this.treeDataC, item));
              arrid.push(this.findPnodeId(this.treeDataC, item));
            }
          });
           console.log(arrid);
          this.cwCheckedKeysC = this.cwCheckedKeysC.concat(checkedKeys);
          this.$emit("sitenameC", arr, this.cwCheckedKeysC,arrid);
        } else {
          if (this.cwCheckedKeysC.indexOf(node.eventKey) !== -1) {
            this.cwCheckedKeysC.splice(
              this.cwCheckedKeysC.indexOf(node.eventKey),
              1
            );
          }

          let arr = [];
          this.cwCheckedKeysC.forEach((item) => {
            for (let i = 0; i < this.treeDataC.length; i++) {
              this.treeDataC[i]

            }
            if (this.getName(this.treeDataC, item)) {
              arr.push(this.getName(this.treeDataC, item));
            }
          });
          this.$emit("sitenameC", arr, this.cwCheckedKeysC);
        }
      },
      onCheck(checkedKeys, {
        checked,
        checkedNodes,
        node,
        event
      }) {
        console.log(checkedKeys, node);
        this.$emit("sitenamenum", checkedKeys);
        this.cwCheckedKeys = Array.from(new Set(this.checkedKeys));
        if (checked) {
          let arr = [];
          let cKeys = checkedKeys;
          cKeys = checkedKeys;
          cKeys.forEach((item) => {
            if (this.getName(this.treeData, item)) {
              arr.push(this.getName(this.treeData, item));
            }
          });
          this.cwCheckedKeys = this.cwCheckedKeys.concat(checkedKeys);
          this.$emit("sitename", arr, this.cwCheckedKeys);
        } else {
          if (this.cwCheckedKeys.indexOf(node.eventKey) !== -1) {
            this.cwCheckedKeys.splice(
              this.cwCheckedKeys.indexOf(node.eventKey),
              1
            );
          }
          if (node.dataRef.children.length > 0) {
            let nodeChildren = node.dataRef.children;
            this.judgeChildren(nodeChildren);
          }

          this.setKeyParent(this.treeData);
          let fatherData = this.getParent(this.treeData, node.eventKey);
          if (fatherData.length > 2) {
            if (this.cwCheckedKeys.indexOf(fatherData[1].key) !== -1) {
              this.cwCheckedKeys.splice(
                this.cwCheckedKeys.indexOf(fatherData[1].key),
                1
              );
            }
          } else {
            if (this.cwCheckedKeys.indexOf(fatherData[0].key) !== -1) {
              this.cwCheckedKeys.splice(
                this.cwCheckedKeys.indexOf(fatherData[0].key),
                1
              );
            }
          }
          let arr = [];
          this.cwCheckedKeys.forEach((item) => {
            // console.log('item',this.getName(this.treeData,item));
            if (this.getName(this.treeData, item)) {
              arr.push(this.getName(this.treeData, item));
            }
          });
          console.log(arrid, "///////");
          this.$emit("sitename", arr, this.cwCheckedKeys);
        }
        // console.log(node);
      },
      onSelect(searchValueselectedKeys, info) {
        this.selectedKeys = selectedKeys;
      },
      onSelectC(selectedKeys, info) {
        this.selectedKeysC = selectedKeys;
      },

      //递归
      judgeChildren(array) {
        for (let i in array) {
          var data = array[i];
          if (this.cwCheckedKeys.indexOf(data.key) !== -1) {
            this.cwCheckedKeys.splice(this.cwCheckedKeys.indexOf(data.key), 1);
          }
          if (data.children) {
            this.judgeChildren(data.children);
          }
        }
      },
      getParent(data2, nodeId2) {
        var arrRes = [];
        if (data2.length == 0) {
          if (!!nodeId2) {
            arrRes.unshift(data2);
          }
          return arrRes;
        }
        let rev = (data, nodeId) => {
          for (var i = 0, length = data.length; i < length; i++) {
            let node = data[i];
            if (node.key == nodeId) {
              arrRes.unshift(node);
              rev(data2, node.parentKey); // 注意这里是传入的tree，不要写成data了，不然遍历的时候一直都是node.children,不是从最顶层开始遍历的
              break;
            } else {
              if (!!node.children) {
                rev(node.children, nodeId);
              }
            }
          }
          return arrRes;
        };
        arrRes = rev(data2, nodeId2);
        return arrRes;
      },
      setKeyParent(tree) {
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.children.length > 0) {
            for (let j = 0; j < node.children.length; j++) {
              node.children[j].parentKey = node.key;
              this.setKeyParent(node.children);
            }
          }
        }
      },

      getName(tree, id) {
        let name = "";
        var fn = function (tree, id) {
          for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.key == id) {
              name = node;
              break;
            } else {
              if (node.children.length > 0) {
                fn(node.children, id);
              }
            }
          }
        };
        fn(tree, id);
        return name;
      },
    },
    created() {
      this.id = this.selectid;
      this.cwCheckedKeys = this.checkedKeys;
    },
    activated() {},
    mounted() {},
  };
</script>
<style lang="scss" scope>
  .person {
    width: 100%;
    // background:#06347f;
    overflow: hidden;

    .ant-input-search {}

    .treelist {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      // p {
      //     padding-left: 20px;
      //     width: 100px;
      //     font-size: 14px;
      //     font-family: PingFangSC-Semibold, PingFang SC;
      //     font-weight: 600;
      //     color: #333333;
      // }
      .tab {
        @include flex(flex-start);
        cursor: pointer;
        position: relative;
        margin-right: 24px;
        margin-right: 8px;
        font-size: 14px;
        color: #666666;

        /deep/ .ant-scroll-number {
          width: 32px;
          height: 20px;
          background: rgba(140, 140, 140, 0.1);
          border-radius: 12px;

          .ant-scroll-number-only {
            color: #000000;
          }
        }

        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          position: absolute;
          right: 0;
          bottom: -8px;
          background: #106aff;
          transform: scale3d(0, 1, 1);
          transition: all 0.3s ease-in-out;
        }

        &:hover {
          &::after {
            transform: scale3d(1, 1, 1);
          }
        }

      }

      .active {
        font-weight: 600;

        /deep/ .ant-scroll-number {
          width: 32px;
          height: 20px;
          background: $four-level-bj-color;
          border-radius: 12px;

          .ant-scroll-number-only {
            color: #106aff;
          }
        }

        &::after {
          transform: scale3d(1, 1, 1);
        }

      }
    }

    .ant-tree-treenode-checkbox-checked {
      //   display: flex;
    }

    .person-tree {
      color: #00adff;

      .ant-tree-title {
        color: #00adff;
      }
    }

    li.ant-tree-treenode-disabled>.ant-tree-node-content-wrapper span {}

    .ant-tree li .ant-tree-node-content-wrapper {
      width: 100%;
      // background: #F6F7FB;
      color: rgba(0, 0, 0, 0.65) !important;
    }

    .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
      color: #00adff;
      background: rgba(0, 60, 117, 1);
    }

    .ant-tree.ant-tree-show-line li:not(:last-child)::before {
      border-left: 1px dashed #00adff;
      top: 6px;
      height: calc(90%);
    }

    .ant-tree>li:last-child {
      // background: #F6F7FB;
    }
  }
</style>